import React from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

function Loading() {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255,255,255,0.0)',
        color: 'white',
        display: 'flex',
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'rgba(77,77,77,0.8)',
          padding: '8px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '8px',
          backdropFilter: 'blur(1px)',
          textAlign: 'center',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'rgba(77,77,77,0.9)',
          '> p': {
            fontSize: '0.55rem',
          },
          '.loader_inner': {
            borderColor: 'loader.main',
          },
        }}
      >
        <div className="loader">
          <div className="loader_inner one"></div>
          <div className="loader_inner two"></div>
          <div className="loader_inner three"></div>
        </div>

        <Typography sx={{ marginTop: '8px' }}>Brevet INPI</Typography>
        <Typography>
          POWER BY
          <Typography variant="span" sx={{ display: 'block' }}>
            ARKA-STUDIO
          </Typography>
        </Typography>
      </Box>
    </Box>
  );
}

export default Loading;
